import { Component, Input, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Collection, Tag } from '@portals/api';
import { BaseComponent, DrawerService } from '@portals/core';

@Component({
	selector: 'portals-intake-detail-drawer',
	templateUrl: './intake-detail-drawer.component.html',
	styleUrls: ['./intake-detail-drawer.component.scss'],
})
export class IntakeDetailDrawerComponent extends BaseComponent implements OnInit {
	tags!: Array<Tag>;
	latitude = 5.6208461;
	longitude = -0.2038178;
	get intakeVideo() {
		// @ts-ignore
		return this.drawer.context[0] as Record<string, string>;
	}

	get intakeDuration() {
		// @ts-ignore
		return this.drawer.context[1] as Record<string, unknown>;
	}

	get intakeStatus() {
		// @ts-ignore
		return this.drawer.context[2] as Record<string, unknown>;
	}

	get intakeComments() {
		// @ts-ignore
		return this.drawer.context[3].Comments as Record<string, any>;
	}

	get intakeTags() {
		// @ts-ignore
		return this.drawer.context[4].Tags as Record<string, any>;
	}

	constructor(public drawer: DrawerService<Record<string, unknown>>) {
		super();
	}

	ngOnInit(): void {
		// @ts-ignore
		this.tags = this.drawer.context[4].Tags;

		// //@ts-ignore
		// this.latitude = this.drawer?.context[5]?.latitude;
		// //@ts-ignore
		// this.longitude = this.drawer?.context[5]?.longitude;
	}
}
